import React from 'react';
import { Link } from 'react-router-dom';
import "./Header.css";

function Header() {
  return (
    <div className='header'>
        <Link to='/' className='pandora-logo'>Pandora Inc Studios</Link>
        <nav className='pandora-nav'>
            <Link to='/about'>About</Link>
            <Link to='/contact'>Contact</Link>
        </nav>
    </div>
  )
}

export default Header;